module.exports = __webpack_public_path__ + "images/category_lp/musical_instrument/new/assessment_achievements/2_7e89563a0b9ae93485615df9cbc337a9.png";